import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Component 1" }, [
      _createElementVNode("path", {
        id: "Icon",
        d: "M5.53174 15.7017H34.4683M16.9541 6.67188L13.9081 15.7017L20 33.009L26.0919 15.7017L23.0459 6.67188M20.936 32.6516L34.5798 16.4725C34.811 16.1983 34.9266 16.0612 34.9708 15.9082C35.0097 15.7732 35.0097 15.6302 34.9708 15.4953C34.9266 15.3423 34.811 15.2052 34.5798 14.931L27.9802 7.10509C27.8459 6.94585 27.7788 6.86623 27.6965 6.80899C27.6235 6.75827 27.5422 6.72061 27.456 6.69771C27.3589 6.67188 27.254 6.67188 27.0442 6.67188H12.9558C12.746 6.67188 12.6411 6.67188 12.544 6.69771C12.4578 6.72061 12.3765 6.75827 12.3035 6.80899C12.2212 6.86623 12.1541 6.94585 12.0198 7.10509L5.42024 14.931C5.18901 15.2052 5.0734 15.3423 5.02921 15.4953C4.99026 15.6302 4.99026 15.7732 5.02921 15.9082C5.0734 16.0612 5.18901 16.1983 5.42024 16.4725L19.064 32.6516C19.3854 33.0327 19.5462 33.2233 19.7386 33.2928C19.9074 33.3538 20.0926 33.3538 20.2614 33.2928C20.4538 33.2233 20.6146 33.0327 20.936 32.6516Z",
        stroke: "#401D42",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }